import { AxiosInstance } from 'axios';
import { Thought } from './types';

export interface ThoughtInput {
  body: string;
  subBody: string | null;
  lessonId: number;
  rotationNumber: number;
}

export function thoughtsApi(client: AxiosInstance) {
  return {
    getList: () =>
      client.post<{ items: Thought[] }>('/api/v1/admin/thoughts/get-list', {}),
    getById: (id: number) =>
      client.post<Thought>('/api/v1/admin/thoughts/get-by-id', { id }),
    create: (data: ThoughtInput) =>
      client.post<Thought>('/api/v1/admin/thoughts/create', data),
    update: (data: ThoughtInput & { id: number }) =>
      client.post<Thought>('/api/v1/admin/thoughts/update', data),
    delete: (id: number) =>
      client.post<void>('/api/v1/admin/thoughts/delete', { id }),
    batchDelete: (ids: number[]) =>
      client.post<{ deleted: number[] }>('/api/v1/admin/thoughts/batch-delete', { ids }),
  };
}
